import { render } from "./slidesQuestion.vue?vue&type=template&id=35182afc&scoped=true"
import script from "./slidesQuestion.vue?vue&type=script&lang=js"
export * from "./slidesQuestion.vue?vue&type=script&lang=js"

import "./slidesQuestion.vue?vue&type=style&index=0&id=35182afc&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35182afc"]])

export default __exports__